export const imageURL = {
    url : 'https://magic.adorntourism.com/Upload/'
}
